export const AUTO_DELEVERAGE_LIQ_LTV_TOOLTIP_CONTENT =
  'The LTV threshold where liquidators can start partially unwinding your position.'
